import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-751be0e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_modal_wrap" }
const _hoisted_2 = { class: "modal_place_input" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, "审核链接：", -1))
const _hoisted_4 = { class: "modal_place_input_content" }
const _hoisted_5 = { class: "operate_btn_box" }
const _hoisted_6 = { class: "modal_place_input" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, "审核密码：", -1))
const _hoisted_8 = { class: "modal_place_input_content" }
const _hoisted_9 = { class: "operate_btn_box" }
const _hoisted_10 = { class: "modal_place_input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, null, -1))
const _hoisted_12 = { class: "modal_place_input_content btn" }
const _hoisted_13 = { class: "modal_place_input" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_place_input_title" }, "审核权限：", -1))
const _hoisted_15 = { class: "modal_place_input_content" }

import { withDefaults, watch, ref, computed } from 'vue';
import { Input, Checkbox, message } from 'ant-design-vue';
import ClipboardJS from 'clipboard';
import { useLiveStore } from '@/pinia/live';
interface IProps {
  modelValue: {
    readonly other_link: string;
    readonly password: string;
    readonly reg: boolean; //观众注册权限
    readonly exa: boolean; //观众审核
  };
}

const __default__ = { name: 'ModalSubAuto' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: {
    readonly other_link: string;
    readonly password: string;
    readonly reg: boolean; //观众注册权限
    readonly exa: boolean; //观众审核
  };
};

const liveStore = useLiveStore();
const liveInfo = computed(() => liveStore.liveInfo);
const aInput = Input;
const aCheckbox = Checkbox;


const form = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    form.value = props.modelValue;
  }
);
watch(form.value, (newVal) => {
  emit('update:modelValue', newVal);
});

const readonly = ref(true);
const showReadonly = () => {
  readonly.value = false;
};

const textCopy = ref();
textCopy.value =
  `活动名称：${liveInfo.value.title}\n` + `审核链接：${form.value.other_link}\n` + `审核密码：${form.value.password}\n`;
const Copylist = (btns: string) => {
  let ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', function (e) {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', function () {
    message.destroy();
    message.info('复制失败');
  });
};

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(aInput), {
          value: form.value.other_link,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.other_link) = $event)),
          readonly: "",
          class: "mpic_input"
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          type: "link",
          class: "operate_btn first copy1",
          "data-clipboard-text": form.value.other_link,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (Copylist('.copy1')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "other_review_copy" })
          ]),
          _: 1
        }, 8, ["data-clipboard-text"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "operate_btn",
          href: form.value.other_link,
          target: "block"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "other_review_url" })
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(aInput), {
          value: form.value.password,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.password) = $event)),
          readonly: readonly.value,
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (readonly.value = true)),
          class: "mpic_input"
        }, null, 8, ["value", "readonly"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_a_button, {
          type: "link",
          class: "operate_btn first copy2",
          "data-clipboard-text": form.value.password,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (Copylist('.copy2')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "other_review_copy" })
          ]),
          _: 1
        }, 8, ["data-clipboard-text"]),
        _createVNode(_component_a_button, {
          type: "link",
          class: "operate_btn",
          onClick: showReadonly
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_icon, { "icon-class": "other_review_edit" })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_a_button, {
          class: "mod_btn mod_btn_primary order copy3",
          "data-clipboard-text": textCopy.value,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (Copylist('.copy3')))
        }, {
          default: _withCtx(() => [
            _createTextVNode("一键复制")
          ]),
          _: 1
        }, 8, ["data-clipboard-text"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_unref(aCheckbox), {
          checked: form.value.reg,
          "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((form.value.reg) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("观众注册")
          ]),
          _: 1
        }, 8, ["checked"]),
        _createVNode(_unref(aCheckbox), {
          checked: form.value.exa,
          "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((form.value.exa) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("观众审核")
          ]),
          _: 1
        }, 8, ["checked"])
      ])
    ])
  ]))
}
}

})